<template>
	<div class="submenu-container">
		<span class="mobile-dropdown" :class="{ active }" @click="active = !active" />
		<div class="submenu" :class="{ active: hideAll ? resetState() : active }">
			<ul>
				<li v-for="item in subitems" :key="item.filename">
					<nuxt-link :to="`${item.filename}`" @click="hideMobileNav">
						{{ item.header }}
					</nuxt-link>
				</li>
			</ul>
		</div>
	</div>
</template>

<script setup>
defineProps({
	subitems: { type: Array, default: () => [] },
	hideAll: { type: Boolean, default: false },
});

const emit = defineEmits(['hide-mobile-nav']);

const active = ref(false);

const resetState = () => {
	active.value = false;
};

const hideMobileNav = () => {
	emit('hide-mobile-nav');
};
</script>

<style lang="scss" scoped>
.submenu-container {
	position: absolute;
	width: 150px;
	padding: 20px;
}

a {
	font-weight: 300;
	color: #fff;
	text-decoration: none;
	position: relative;

	&::after {
		content: '';
		position: absolute;
		left: 50%;
		top: 18px;
		bottom: 0;
		width: 0;
		height: 2px;
		background-color: #fff;
		transition:
			width 0.3s ease-in-out,
			left 0.3s ease-in-out;
	}

	&.router-link-active,
	&:hover {
		color: #fff;

		&::after {
			width: 100%;
			left: 0;
		}
	}
}

.mobile-dropdown {
	display: none;
	width: 12px;
	height: 8px;
	background: url('~/assets/images/icon-dropdown-white.png') center center no-repeat;
	margin-bottom: 3px;

	&.active {
		transform: rotate(180deg);
	}
}

.submenu {
	ul {
		display: none;
		background: #3f3e3e;
		position: absolute;
		top: 25px;
		left: 0;
		text-align: left;
		padding: 7px;

		&.active {
			display: block;
		}

		li {
			padding: 10px 0;
			list-style: none;

			a {
				margin: 0 10px;
				text-decoration: none;
				font-size: 13px;
				font-weight: 400;
				letter-spacing: 1px;
			}
		}
	}

	&.active ul {
		display: block;
	}
}

@media (max-width: 1200px) {
	.mobile-dropdown {
		display: inline-block;
	}

	.submenu-container {
		display: inline;
		position: relative;
		padding: 0;
	}

	.submenu ul {
		position: static;
		background: transparent;
		text-align: left;
		text-transform: uppercase;
		padding: 15px;
	}
}
</style>
